/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeParagraph, BaSeToggler } from '@base/react';
import React from 'react';
import { AlignFilds, CustomFilterWrapperAlign } from '../../candidates-styled';

function RegisteredPortal({
  handleChange,
  filters,
  insideFilter,
  fixedFilters,
  handleFixedFilter,
  handleChangeCustomFilter,
  setFilter,
}) {
  return (
    <CustomFilterWrapperAlign>
      <BaSeParagraph color="#939393">Cadastros do portal</BaSeParagraph>

      <AlignFilds>
        <BaSeToggler
          value={filters.registeredOnPortal}
           color={!filters.registeredOnPortal ? '#939393' : ''}
          onChange={() => {
            setFilter((prev) => {
              return {
                ...prev,
                origin: !filters.registeredOnPortal ? 'LANDING_PAGE' : '',
              };
            });
            handleChange('registeredOnPortal', !filters.registeredOnPortal);

            if (filters.myRecords) {
              handleChange('myRecords', false);
            }
            handleChange(
              'origin',
              filters.registeredOnPortal ? 'LANDING_PAGE' : '',
            );
          }}
        />
      </AlignFilds>
    </CustomFilterWrapperAlign>
  );
}

export default RegisteredPortal;
